/* istanbul ignore file */
// TODO: Create test file

import { computed, inject } from 'vue';
import useCopyData from './useCopyData';
import usePhotoData from './usePhotoData';

export default function useBrandData() {
  const brandData = inject('brandData');

  const brandName = computed(() => brandData?.value?.brandName || '');
  const storeFrontUrl = computed(() => brandData?.value?.storeFrontUrl || '');
  return {
    ...useCopyData({ type: 'brand', copy: brandName }),
    ...usePhotoData({ type: 'brand', photo: brandName }),
    storeFrontUrl,
  };
}
